import { C, FONTS } from '../../tokens/design';

const TIER_MAP = {
  'Baseline':     [C.gry, C.gryBg],
  'BaselinePlus': [C.sky, C.skyBg],
  'Baseline+':    [C.sky, C.skyBg],
  'Supreme':      [C.gld, C.gldBg],
};

const TIER_INT_MAP = { 0: 'Baseline', 1: 'Baseline+', 2: 'Supreme' };

export default function TierBadge({ value }) {
  const label = typeof value === 'number' ? (TIER_INT_MAP[value] ?? 'Baseline') : (value || 'Baseline');
  const [color, bg] = TIER_MAP[label] || TIER_MAP.Baseline;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 3,
      padding: '2px 8px', borderRadius: 9999,
      fontSize: 10, fontWeight: 700, letterSpacing: '0.06em',
      textTransform: 'uppercase', fontFamily: FONTS.mono,
      color, background: bg, border: `1px solid ${color}44`,
    }}>
      {label === 'Supreme' && <span>★</span>}
      {label}
    </span>
  );
}
